export const RECORDS_PAGE_SIZE = 2000;

// Mirrors MAX_DISPLAY_NAME_LENGTH in hg/constants.py. Not in slug.ts with the
// nickname bounds: a display name is not a URL name and goes through none of
// that normalization.
export const MAX_DISPLAY_NAME_LENGTH = 64;

export const API_URL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api`;
